import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
import { IconSize } from '@foundation/Icon/IconSize';

import IconMarginBottom12 from './IconMarginBottom12';
import IconMarginBottom16 from './IconMarginBottom16';
import IconMarginBottom20 from './IconMarginBottom20';
import IconMarginBottom24 from './IconMarginBottom24';
import IconMarginBottom32 from './IconMarginBottom32';

/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
const IconMarginBottom = (props: GeneratedIconProps): ReactElement<GeneratedIconProps> => {
    const size = props.size || IconSize.Size16;
    return (
        <span>
            {size === IconSize.Size12 && !props.filled && <IconMarginBottom12 {...props} />}
            {size === IconSize.Size16 && !props.filled && <IconMarginBottom16 {...props} />}
            {size === IconSize.Size20 && !props.filled && <IconMarginBottom20 {...props} />}
            {size === IconSize.Size24 && !props.filled && <IconMarginBottom24 {...props} />}
            {size === IconSize.Size32 && !props.filled && <IconMarginBottom32 {...props} />}
        </span>
    );
};
IconMarginBottom.displayName = 'FondueIconMarginBottom';

export default memo(IconMarginBottom);
